import { Center, Loader, Stack, Text } from '@mantine/core';

export function AppShellSkeleton() {
  return (
    <Center style={{ minHeight: '60vh' }}>
      <Stack align="center" gap="sm">
        <Loader />
        <Text c="dimmed" size="sm">
          Loading…
        </Text>
      </Stack>
    </Center>
  );
}
